import { CROWN_COPYRIGHT_TEXT } from '../constants/AppConstants';
import { CROWN_COPYRIGHT_URL, FOOTER_LINKS } from '../constants/AppUrlConstants';

const Footer = () => {
  return (
    <footer id="footer" className="govuk-footer">
      <div className="govuk-width-container ">
        <div className="govuk-footer__meta">
          <div className="govuk-footer__meta-item govuk-footer__meta-item--grow">
            <h2 className="govuk-visually-hidden">Support links</h2>
            <ul id="footer-navigation" className="govuk-footer__inline-list">
              {Object.entries(FOOTER_LINKS).map(([id, { url, text }]) => (
                <li key={id} className="govuk-footer__inline-list-item">
                  <a className="govuk-footer__link" href={url}>
                    {text}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="govuk-footer__meta-item">
            <a
              className="govuk-footer__link govuk-footer__copyright-logo"
              href={CROWN_COPYRIGHT_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              {CROWN_COPYRIGHT_TEXT}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
